
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30102',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30102",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54271",
  "head-dlb": "static-1.4938",
  "hs-test-utils": "static-1.7916",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11360",
  "I18n": "static-7.1603",
  "quartz": "static-1.6875",
  "quartz-config": "static-1.653",
  "quartz-core": "static-1.6094",
  "react-dlb": "static-1.77",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.770",
  "enviro": "static-4.428",
  "feedback-shared-ui": "static-1.54258",
  "feedback-utils": "static-1.54262",
  "forms-embed-utils-lib": "static-1.4366",
  "forms-utils-lib": "static-1.12401",
  "foundations-assets": "static-1.4753",
  "foundations-components": "static-1.7733",
  "foundations-theming": "static-1.4318",
  "hub-http": "static-1.6123",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11668",
  "icons": "static-2.639",
  "immutable": "static-2.77",
  "quick-fetch": "static-1.3839",
  "raven": "static-3.5829",
  "react": "static-7.184",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16560",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5271",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.485",
  "tinymce-plugins": "static-1.57203",
  "transmute": "static-2.85",
  "ui-images": "static-2.1130",
  "UIComponents": "static-3.8307",
  "hs-promise-rejection-tracking": "static-1.5489",
  "PortalIdParser": "static-2.388",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9542",
  "styled-components": "static-2.88",
  "bend-plugin-trellis-migration": "static-1.3329",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3152",
  "quartz-webpack": "static-1.3099",
  "foundations-theming-specialty": "static-1.2034",
  "property-description-translator": "static-1.3757",
  "HeadJS": "static-2.735",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3027",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4228",
  "jasmine-runner": "static-1.6372",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.819",
  "hubspotter-http": "static-1.4575",
  "mobile-manifest-mixins": "static-1.508",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.550",
  "quartz-head": "static-1.540",
  "quartz-i18n": "static-1.550",
  "quartz-routing": "static-1.305",
  "quartz-test": "static-1.550",
  "quartz-tracking": "static-1.254",
  "ui-fonts": "static-1.622",
  "usage-tracker-container": "static-1.7229",
  "usage-tracker-core": "static-1.7089",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.154",
  "conversations-skeleton-state": "static-1.7155",
  "reference-resolvers": "static-1.8071",
  "sanitize-text": "static-1.8049",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10278",
  "sanitize": "static-1.4377",
  "outpost": "static-1.4099",
  "rpc-client-utils": "static-1.4548",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4002",
  "floating-ui": "static-1.54",
  "hs-story-utils": "static-1.9334",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1544",
  "bend-plugin-foundations-theming": "static-1.2801",
  "foundations-theming-base": "static-1.3303",
  "stylex": "static-1.30",
  "csstype": "static-1.50",
  "ai-components-ui-library": "static-1.8696",
  "atom": "static-1.4975",
  "codemirror": "static-5.93",
  "content-assistance-lib": "static-1.7611",
  "ContentUtils": "static-1.68059",
  "data-token-picker": "static-1.16236",
  "file-manager-components": "static-1.23315",
  "FileManagerCore": "static-1.38814",
  "FileManagerLib": "static-1.38955",
  "frontend-preferences-client": "static-1.7828",
  "hub-http-contrib": "static-1.2947",
  "interframe": "static-3.4667",
  "layout-dnd-components": "static-1.12260",
  "layout-dnd-utils": "static-1.11235",
  "property-translator": "static-1.5312",
  "react-codemirror": "static-1.10528",
  "react-colorpicker": "static-2.10113",
  "reference-resolvers-lite": "static-1.7993",
  "rich-text-lib": "static-1.19665",
  "tinymce-data": "static-1.40174",
  "tinymce-themes": "static-1.56059",
  "ui-addon-emoji-picker": "static-1.9791",
  "ui-addon-sales-email": "static-1.5116",
  "ui-brand-identity-lib": "static-1.14810",
  "bender-build-tools": "static-1.3063",
  "hub-http-shared-msw-handlers": "static-1.9740",
  "hubspotter-http-shared-msw-handlers": "static-1.9738",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "usage-tracker-session-replay": "static-1.4925",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "chirp-fetch": "static-1.1785",
  "chatspot-core": "static-1.20832",
  "copilot-toolkit": "static-1.10859",
  "data-fetching-client": "static-1.9579",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4673",
  "ui-addon-video-player": "static-1.8601",
  "ui-coaching-tips": "static-1.28270",
  "usage-tracker": "static-1.7239",
  "cms-field-types": "static-1.4714",
  "content-icons-ui": "static-1.2203",
  "integrations-lib": "static-1.15802",
  "customer-data-objects": "static-1.7563",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4555",
  "apollo-stack-hubspot": "static-3.84",
  "graphql": "static-1.80",
  "immer": "static-1.33",
  "immerable": "static-1.4057",
  "ui-addon-iframeable": "static-1.8954",
  "video-components-external": "static-1.10964",
  "video-data-lib": "static-1.34622",
  "audio-components": "static-1.5773",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29117",
  "FileManagerImages": "static-1.36466",
  "foundations-components-legacy": "static-1.758",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.523",
  "ui-universal-auth": "static-1.8843",
  "urlinator": "static-1.4436",
  "video-components": "static-1.12967",
  "video-embed": "static-1.35456",
  "ts-schema": "static-1.4001",
  "ContentData": "static-1.68134",
  "layout-data-lib": "static-1.9560",
  "react-dnd-compat": "static-1.4522",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1457",
  "external-options-client-types": "static-1.4081",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6779",
  "hs-promise-utils": "static-1.5498",
  "inbound-db-properties-service-client": "static-1.3769",
  "NamespacedHubStyle": "static-2.8990",
  "growth-onboarding-confetti": "static-1.2975",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11052",
  "amplitude-session-replay-browser": "static-1.58",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5498",
  "magpie-types": "static-1.4958",
  "simple-logging-lib": "static-1.2956",
  "growth-onboarding-feedback-components": "static-1.6486",
  "flux-actions": "static-1.325",
  "hubspot-apollo-client": "static-1.4782",
  "integrations-error-boundary-lib": "static-1.13217",
  "integrations-tracking-lib": "static-1.5500",
  "laboratory-lib": "static-3.7063",
  "native-integrations-shared-strings": "static-1.7690",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10052",
  "unified-auth": "static-1.357",
  "navigation-messaging": "static-1.6994",
  "content-media-composition-data-lib": "static-1.11932",
  "content-media-compositions": "static-2.15939",
  "idb-keyval": "static-1.42",
  "media-bridge-lib": "static-1.18756",
  "unified-auth-core-lib": "static-1.638",
  "social-insights-client-types": "static-1.21805",
  "advanced-menus-core": "static-1.14980",
  "advanced-menus-lib": "static-1.11941",
  "ExportDialog": "static-6.10294",
  "ui-memberships-settings-lib": "static-1.33776",
  "conditional-properties-service-client": "static-1.3720",
  "crm-pipelines-api-client-types": "static-1.4065",
  "framework-builder-read-service-client": "static-1.3932",
  "framework-data-schema-quick-fetch": "static-1.6684",
  "inbound-db-meta-service-client": "static-1.3513",
  "multi-currency-client-types": "static-1.3614",
  "persist-promise": "static-1.3614",
  "foundations-components-test-utils": "static-1.5216",
  "reactive-lib": "static-1.628",
  "hubspot-apollo-cache": "static-1.241",
  "universal-page-editor-lib": "static-1.2911",
  "microsoft-drive-integration-lib": "static-1.37",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3638",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14979",
  "simple-menus-lib": "static-1.16496",
  "crm-record-cards-service-types": "static-1.3533",
  "location-customization-utils-lib": "static-1.8935",
  "react-flip-move": "static-1.68"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30102",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54271",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-test-utils": "/hs-test-utils/static-1.7916",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11360",
  "I18n": "/I18n/static-7.1603",
  "quartz": "/quartz/static-1.6875",
  "quartz-config": "/quartz-config/static-1.653",
  "quartz-core": "/quartz-core/static-1.6094",
  "react-dlb": "/react-dlb/static-1.77",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.770",
  "enviro": "/enviro/static-4.428",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54258",
  "feedback-utils": "/feedback-utils/static-1.54262",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4366",
  "forms-utils-lib": "/forms-utils-lib/static-1.12401",
  "foundations-assets": "/foundations-assets/static-1.4753",
  "foundations-components": "/foundations-components/static-1.7733",
  "foundations-theming": "/foundations-theming/static-1.4318",
  "hub-http": "/hub-http/static-1.6123",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11668",
  "icons": "/icons/static-2.639",
  "immutable": "/immutable/static-2.77",
  "quick-fetch": "/quick-fetch/static-1.3839",
  "raven": "/raven/static-3.5829",
  "react": "/react/static-7.184",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16560",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5271",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tinymce-plugins": "/tinymce-plugins/static-1.57203",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1130",
  "UIComponents": "/UIComponents/static-3.8307",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9542",
  "styled-components": "/styled-components/static-2.88",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3329",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3152",
  "quartz-webpack": "/quartz-webpack/static-1.3099",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2034",
  "property-description-translator": "/property-description-translator/static-1.3757",
  "HeadJS": "/HeadJS/static-2.735",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3027",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4228",
  "jasmine-runner": "/jasmine-runner/static-1.6372",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.819",
  "hubspotter-http": "/hubspotter-http/static-1.4575",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.508",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.550",
  "quartz-head": "/quartz-head/static-1.540",
  "quartz-i18n": "/quartz-i18n/static-1.550",
  "quartz-routing": "/quartz-routing/static-1.305",
  "quartz-test": "/quartz-test/static-1.550",
  "quartz-tracking": "/quartz-tracking/static-1.254",
  "ui-fonts": "/ui-fonts/static-1.622",
  "usage-tracker-container": "/usage-tracker-container/static-1.7229",
  "usage-tracker-core": "/usage-tracker-core/static-1.7089",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.154",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7155",
  "reference-resolvers": "/reference-resolvers/static-1.8071",
  "sanitize-text": "/sanitize-text/static-1.8049",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10278",
  "sanitize": "/sanitize/static-1.4377",
  "outpost": "/outpost/static-1.4099",
  "rpc-client-utils": "/rpc-client-utils/static-1.4548",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4002",
  "floating-ui": "/floating-ui/static-1.54",
  "hs-story-utils": "/hs-story-utils/static-1.9334",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1544",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2801",
  "foundations-theming-base": "/foundations-theming-base/static-1.3303",
  "stylex": "/stylex/static-1.30",
  "csstype": "/csstype/static-1.50",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8696",
  "atom": "/atom/static-1.4975",
  "codemirror": "/codemirror/static-5.93",
  "content-assistance-lib": "/content-assistance-lib/static-1.7611",
  "ContentUtils": "/ContentUtils/static-1.68059",
  "data-token-picker": "/data-token-picker/static-1.16236",
  "file-manager-components": "/file-manager-components/static-1.23315",
  "FileManagerCore": "/FileManagerCore/static-1.38814",
  "FileManagerLib": "/FileManagerLib/static-1.38955",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7828",
  "hub-http-contrib": "/hub-http-contrib/static-1.2947",
  "interframe": "/interframe/static-3.4667",
  "layout-dnd-components": "/layout-dnd-components/static-1.12260",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11235",
  "property-translator": "/property-translator/static-1.5312",
  "react-codemirror": "/react-codemirror/static-1.10528",
  "react-colorpicker": "/react-colorpicker/static-2.10113",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7993",
  "rich-text-lib": "/rich-text-lib/static-1.19665",
  "tinymce-data": "/tinymce-data/static-1.40174",
  "tinymce-themes": "/tinymce-themes/static-1.56059",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9791",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5116",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14810",
  "bender-build-tools": "/bender-build-tools/static-1.3063",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9740",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9738",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4925",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "chirp-fetch": "/chirp-fetch/static-1.1785",
  "chatspot-core": "/chatspot-core/static-1.20832",
  "copilot-toolkit": "/copilot-toolkit/static-1.10859",
  "data-fetching-client": "/data-fetching-client/static-1.9579",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4673",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8601",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28270",
  "usage-tracker": "/usage-tracker/static-1.7239",
  "cms-field-types": "/cms-field-types/static-1.4714",
  "content-icons-ui": "/content-icons-ui/static-1.2203",
  "integrations-lib": "/integrations-lib/static-1.15802",
  "customer-data-objects": "/customer-data-objects/static-1.7563",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4555",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "graphql": "/graphql/static-1.80",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4057",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8954",
  "video-components-external": "/video-components-external/static-1.10964",
  "video-data-lib": "/video-data-lib/static-1.34622",
  "audio-components": "/audio-components/static-1.5773",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29117",
  "FileManagerImages": "/FileManagerImages/static-1.36466",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.758",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.523",
  "ui-universal-auth": "/ui-universal-auth/static-1.8843",
  "urlinator": "/urlinator/static-1.4436",
  "video-components": "/video-components/static-1.12967",
  "video-embed": "/video-embed/static-1.35456",
  "ts-schema": "/ts-schema/static-1.4001",
  "ContentData": "/ContentData/static-1.68134",
  "layout-data-lib": "/layout-data-lib/static-1.9560",
  "react-dnd-compat": "/react-dnd-compat/static-1.4522",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1457",
  "external-options-client-types": "/external-options-client-types/static-1.4081",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6779",
  "hs-promise-utils": "/hs-promise-utils/static-1.5498",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3769",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8990",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2975",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11052",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5498",
  "magpie-types": "/magpie-types/static-1.4958",
  "simple-logging-lib": "/simple-logging-lib/static-1.2956",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6486",
  "flux-actions": "/flux-actions/static-1.325",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4782",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13217",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5500",
  "laboratory-lib": "/laboratory-lib/static-3.7063",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7690",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10052",
  "unified-auth": "/unified-auth/static-1.357",
  "navigation-messaging": "/navigation-messaging/static-1.6994",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11932",
  "content-media-compositions": "/content-media-compositions/static-2.15939",
  "idb-keyval": "/idb-keyval/static-1.42",
  "media-bridge-lib": "/media-bridge-lib/static-1.18756",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.638",
  "social-insights-client-types": "/social-insights-client-types/static-1.21805",
  "advanced-menus-core": "/advanced-menus-core/static-1.14980",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11941",
  "ExportDialog": "/ExportDialog/static-6.10294",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33776",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3720",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4065",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3932",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6684",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3513",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3614",
  "persist-promise": "/persist-promise/static-1.3614",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5216",
  "reactive-lib": "/reactive-lib/static-1.628",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.241",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2911",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.37",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3638",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14979",
  "simple-menus-lib": "/simple-menus-lib/static-1.16496",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3533",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8935",
  "react-flip-move": "/react-flip-move/static-1.68"
}
};
